export default "__VITE_ASSET__CFNjH3Qu__"